import { Link, useNavigate, useParams } from 'react-router-dom';
import galleryimg from '../assets/images/gallery.png';
import searchicon from '../assets/images/search.png';
import backicon from '../assets/images/back.png';
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearMessage } from '../slices/messages';
import { publicJob } from '../slices/jobs';
import { useTranslation } from 'react-i18next';

const JobsDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {t} = useTranslation();

    const { job } = useSelector((state) => state.jobs);
    const { user } = useSelector((state) => state.auth);

    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';

    useEffect(() => {
        if(user && user.approve == "N") {
            navigate('/profile');
        }
        let param = { id, currentLang };
        dispatch(publicJob(param))
    }, []);

    return (
        <div className="container">
            <section className="mt-5 pt-5 gallery memberDetails">
                <div className="row">
                    <div className='col-md-12'>
                        <Link to='/jobs' className='back-link'>
                            <img src={backicon} style={{ width: "auto" }} />
                        </Link>
                    </div>
                    <div className='col-md-12 mt-2-5'>
                        <div className='section-title'>
                            <h1><span className='font-color-1'>{t('job')}</span> <span className='font-color-2'>{t('details')}</span></h1>
                            
                        </div>
                    </div>

                    <div className='col-md-12 mt-2-5'>
                        <div className='card bg-2 job-details-card'>
                            <div className='card-body'>
                                <div className='job-details'>
                                    <table className='table bg-2'>
                                        <tbody>
                                            <tr>
                                                <td width={200}>{t('title')}</td>
                                                <td>{job?.title}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('contact_no')}</td>
                                                <td>{job?.contact_no}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('qualification')}</td>
                                                <td>{job?.qualification}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('location')}</td>
                                                <td>{job?.location}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('minimum_salary')}</td>
                                                <td>{job?.min_salary}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('maximum_salary')}</td>
                                                <td>{job?.max_salary}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('details')}</td>
                                                <td>{job?.description}</td>
                                            </tr>
                                            <tr>
                                                <td>{t('status')}</td>
                                                <td>
                                                 {job?.job_status == 'Vacant' ? t('Vacant') :  t('Filled') }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
export default JobsDetails;